<template> 
  <div> 
    <div class="d-flex flex-stack flex-wrap">
        <div class="page-title d-flex flex-column me-3 mt-3"> 
            <h1 class="d-flex fw-bolder my-1 fs-3 text-gray-800">{{ $t('update_sales_role_campaign') }} </h1>  
            <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1"> 
                <li class="breadcrumb-item text-gray-600">
                    <a href="#" class="text-gray-600 text-hover-primary">
                        <router-link :to="{ name: 'Home' }">{{ $t('home') }}</router-link>
                    </a>
                </li> 
                <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'Settings' }">{{ $t('settings') }}</router-link></li>     
                <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'CampaignList' }">{{ $t('sales_role_campaign') }}</router-link></li>     
                <li class="breadcrumb-item text-gray-600">{{ $t('update_sales_role_campaign') }}
                    <HelpPageIcon v-if="this.iconView == true" :menuSelection="this.menuSelection"></HelpPageIcon>
                </li> 
            </ul> 
        </div>  
        <div class="d-flex align-items-center py-1">
            <router-link to="/CampaignList">
                <button type="button" class="btn btn-light shadow-sm btn-arrow-left border border-gray-400 me-3">
                <span class="ms-2 fs-7"> {{ $t('return_back_to_list') }}</span>
                </button>
            </router-link> 
            &nbsp;
            <div class="dropdown">
                <button class="btn btn-light-info border border-info dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="true" id="campaignActions" type="button">
                <span class="svg-icon svg-icon-muted"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path opacity="0.3" d="M22.1 11.5V12.6C22.1 13.2 21.7 13.6 21.2 13.7L19.9 13.9C19.7 14.7 19.4 15.5 18.9 16.2L19.7 17.2999C20 17.6999 20 18.3999 19.6 18.7999L18.8 19.6C18.4 20 17.8 20 17.3 19.7L16.2 18.9C15.5 19.3 14.7 19.7 13.9 19.9L13.7 21.2C13.6 21.7 13.1 22.1 12.6 22.1H11.5C10.9 22.1 10.5 21.7 10.4 21.2L10.2 19.9C9.4 19.7 8.6 19.4 7.9 18.9L6.8 19.7C6.4 20 5.7 20 5.3 19.6L4.5 18.7999C4.1 18.3999 4.1 17.7999 4.4 17.2999L5.2 16.2C4.8 15.5 4.4 14.7 4.2 13.9L2.9 13.7C2.4 13.6 2 13.1 2 12.6V11.5C2 10.9 2.4 10.5 2.9 10.4L4.2 10.2C4.4 9.39995 4.7 8.60002 5.2 7.90002L4.4 6.79993C4.1 6.39993 4.1 5.69993 4.5 5.29993L5.3 4.5C5.7 4.1 6.3 4.10002 6.8 4.40002L7.9 5.19995C8.6 4.79995 9.4 4.39995 10.2 4.19995L10.4 2.90002C10.5 2.40002 11 2 11.5 2H12.6C13.2 2 13.6 2.40002 13.7 2.90002L13.9 4.19995C14.7 4.39995 15.5 4.69995 16.2 5.19995L17.3 4.40002C17.7 4.10002 18.4 4.1 18.8 4.5L19.6 5.29993C20 5.69993 20 6.29993 19.7 6.79993L18.9 7.90002C19.3 8.60002 19.7 9.39995 19.9 10.2L21.2 10.4C21.7 10.5 22.1 11 22.1 11.5ZM12.1 8.59998C10.2 8.59998 8.6 10.2 8.6 12.1C8.6 14 10.2 15.6 12.1 15.6C14 15.6 15.6 14 15.6 12.1C15.6 10.2 14 8.59998 12.1 8.59998Z" fill="currentColor"/>
                <path d="M17.1 12.1C17.1 14.9 14.9 17.1 12.1 17.1C9.30001 17.1 7.10001 14.9 7.10001 12.1C7.10001 9.29998 9.30001 7.09998 12.1 7.09998C14.9 7.09998 17.1 9.29998 17.1 12.1ZM12.1 10.1C11 10.1 10.1 11 10.1 12.1C10.1 13.2 11 14.1 12.1 14.1C13.2 14.1 14.1 13.2 14.1 12.1C14.1 11 13.2 10.1 12.1 10.1Z" fill="currentColor"/>
                </svg></span>
                    {{ $t('actions') }}
                </button>
                <ul class="dropdown-menu" aria-labelledby="campaignActions"> 
                    <li>
                        <a class="dropdown-item fs-4 text-danger" href="#" @click="deleteItem()"><span class="svg-icon svg-icon-muted svg-icon-2 text-danger"><svg width="24" height="24" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="currentColor"/>
                        <path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="currentColor"/>
                        <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="currentColor"/>
                        </svg>
                        </span>{{ $t('delete') }} </a>
                    </li>
                </ul>
            </div>  
        </div>
    </div>
    <div class="content flex-row-fluid mt-4" id="kt_content">            
        <StatsBar :form-account="this.form"></StatsBar>            
        <div class="row">
            <div class="card-body">
                <ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6">
                    <li class="nav-item">
                        <a class="nav-link active" data-bs-toggle="tab" href="#kt_accounting_1" target="_self" :class="{'active': this.activeTab == 'inputForm'}">
                            <h4> {{ $t('sales_role_campaign') }} </h4>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="tab" href="#kt_accounting_2" target="_self">
                            <h4> {{ $t('view') }} </h4>
                        </a>
                    </li>
                </ul>
            </div>
            <RequiredField></RequiredField>
            <div class="tab-content" id="myTabContent">
            <div class="card card-xxl-stretch tab-pane fade show active" id="kt_accounting_1" role="tabpanel">
                <div class="row p-10">
                    <div class="col-lg-12 mt-0"> 
                        <div class="d-flex flex-row row">
                            <div class="d-flex flex-column flex-row-auto col-lg-6"> 
                                <div class="d-flex flex-column-fluid card card-xxl-stretch mb-xxl-6 bg-lighten border border-gray-300">
                                    <div class="card-body pb-0">
                                        <div class="row">
                                            <form id="kt_ecommerce_settings_general_form"
                                                class="form fv-plugins-bootstrap5 fv-plugins-framework">                                
                                                <div class="fv-row mb-7 row">
                                                    <div class="col-lg-12">
                                                        <label class="fs-6 fw-bold form-label mt-3 required">
                                                            {{ $t('code') }}
                                                        </label>
                                                        <input type="text" class="form-control" name="code" v-model="form.code">
                                                    </div>
                                                    <div class="col-lg-12">
                                                        <label class="fs-6 fw-bold form-label mt-3 required">
                                                            {{ $t('name') }}
                                                        </label>
                                                        <input type="text" class="form-control" name="name" v-model="form.name">
                                                    </div>
                                                    <div class="col-lg-6">
                                                        <label class="fs-6 fw-bold form-label mt-3" for="isActive">
                                                            {{ $t('is_active') }}
                                                        </label>
                                                        <div class="form-check mt-3 mb-3">
                                                            <input class="form-check-input" type="checkbox" value="" id="isActive" v-model="form.is_active">
                                                        </div> 
                                                    </div>
                                                    <div class="col-lg-6">
                                                        <label class="fs-6 fw-bold form-label mt-3" for="isDefault">
                                                            {{ $t('default') }}
                                                        </label>
                                                        <div class="form-check mt-3 mb-3">
                                                            <input class="form-check-input" type="checkbox" value="" id="isDefault" v-model="form.is_default">
                                                        </div> 
                                                    </div>
                                                </div>
                                            </form>
                                        </div> 
                                    </div>
                                </div> 
                            </div>
                            <div class="d-flex flex-column flex-row-auto col-lg-6">
                                <div class="d-flex flex-column-fluid card card-xxl-stretch mb-xxl-6 bg-lighten border border-gray-300">
                                    <div class="card-header min-h-45px">
                                        <div class="card-title">
                                            {{ $t('invoice_defaults') }}
                                        </div>
                                    </div>
                                    <div class="card-body pb-0">
                                        <div class="row">
                                            <form id="kt_ecommerce_settings_general_form"
                                                class="form fv-plugins-bootstrap5 fv-plugins-framework">
                                                <div class="fv-row mb-7 row">
                                                    <div class="col-lg-4">
                                                        <label class="fs-6 fw-bold form-label mt-3">
                                                            <span>{{ $t('payment_method') }}</span>
                                                        </label>
                                                        <Select2 v-model="form.payment_type_id" :options="paymentTypeList" :settings="{ width: '100%'}"/> 
                                                    </div>
                                                    <div class="col-lg-4">
                                                        <label class="fs-6 fw-bold form-label mt-3">
                                                            <span>{{ $t('shipping_type') }}</span>
                                                        </label>
                                                        <Select2 v-model="form.shipping_type_id" :options="shippingTypeList" :settings="{ width: '100%'}"/> 
                                                    </div>
                                                    <div class="col-lg-4">
                                                        <label class="fs-6 fw-bold form-label mt-3">
                                                            <span>{{ $t('sales_channel') }}</span>
                                                        </label>
                                                        <Select2 v-model="form.sales_channel_id" :options="salesChannelList" :settings="{ width: '100%'}"/> 
                                                    </div>
                                                </div>
                                                <div class="separator"></div>
                                                <div class="fv-row mb-7 row">
                                                    <div class="col-lg-12">
                                                        <label class="fs-6 fw-bold form-label mt-3" for="isAlways">
                                                            {{ $t('always_apply') }}
                                                        </label>
                                                        <div class="form-check mt-3 mb-3">
                                                            <input class="form-check-input" type="checkbox" value="" id="isAlways" v-model="form.is_always">
                                                        </div> 
                                                    </div>
                                                    <div class="col-lg-4">
                                                        <label class="fs-6 fw-bold form-label mt-3">
                                                            <span>{{ $t('payment_value') }}</span>
                                                            <small class="fs-8"> ({{ $t('day') }}) </small>
                                                        </label>
                                                        <CurrencyInput type="text" class="form-control" name="payment_value" v-model="this.form.payment_value" 
                                                        :precision="0" @focus="$event.target.select()" :min="0" @change="onChangePaymentValue()" />
                                                    </div>
                                                    <div class="col-lg-4">
                                                        <label class="fs-6 fw-bold form-label mt-3">
                                                            <span>{{ $t('campaign_start_date') }}</span>
                                                        </label>
                                                        <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.start_date" @update:modelValue="onChangePaymentValue()" :disabled="this.form.is_always"
                                                            inputClassName="form-control" format="dd.MM.yyyy" autoApply :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'"></Datepicker>  
                                                    </div>
                                                    <div class="col-lg-4">
                                                        <label class="fs-6 fw-bold form-label mt-3">
                                                            <span>{{ $t('campaign_end_date') }}</span>
                                                        </label>
                                                        <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.end_date" :disabled="this.form.is_always" inputClassName="form-control" format="dd.MM.yyyy" autoApply :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'"></Datepicker>  
                                                    </div>
                                                </div>
                                            </form>
                                        </div> 
                                    </div>
                                </div> 
                            </div>
                        </div> 
                    </div>
                    <div class="col-lg-12">
                        <div class="card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                            <div class="card-header min-h-45px">
                                <div class="card-title">
                                    {{ $t('item_defaults') }}
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="d-flex flex-stack flex-wrap mb-5">
                                    <div class="d-flex justify-content-end" data-kt-docs-table-toolbar="base">
                                        <button type="button" class="btn btn-sm btn-light btn-active-success me-3" data-bs-toggle="modal" ref="btnAddItem"
                                            data-bs-target="#kt_modal_add_item" @click="openItemModal('addItem')"
                                            data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
                                            <span class="svg-icon svg-icon-2">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                    viewBox="0 0 24 24" fill="none">
                                                    <rect opacity="0.5" x="11.364" y="20.364" width="16" height="2" rx="1"
                                                        transform="rotate(-90 11.364 20.364)" fill="currentColor"></rect>
                                                    <rect x="4.36396" y="11.364" width="16" height="2" rx="1"
                                                        fill="currentColor">
                                                    </rect>
                                                </svg>
                                            </span>
                                            {{ $t('add_item') }}
                                        </button>
                                        <button type="button" class="btn btn-sm btn-light btn-active-primary me-3" data-bs-toggle="modal" ref="btnEditItem"
                                            data-bs-target="#kt_modal_add_item" @click="openItemModal('editItem')" :disabled="isItemButtonDisabled == null || isItemButtonDisabled == undefined"
                                            data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
                                            <span class="svg-icon svg-icon-2">
                                                <span class="svg-icon svg-icon-2">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                        <path opacity="0.3" d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z" fill="currentColor"/>
                                                        <path d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z" fill="currentColor"/>
                                                    </svg>
                                                </span>
                                            </span>
                                            {{ $t('edit') }}
                                        </button>
                                        <button type="button" class="btn btn-sm btn-light btn-active-warning me-3" @click="deleteCampaignItem()" :disabled="isItemButtonDisabled == null || isItemButtonDisabled == undefined">
                                            <span class="svg-icon svg-icon-2">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"/>
                                                </svg>
                                            </span>
                                            {{ $t('remove') }}
                                        </button>
                                        <button type="button" class="btn btn-sm btn btn-light btn-active-danger me-3" @click="deleteAllCampaignItems()">
                                            <span class="svg-icon svg-icon-2">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"/>
                                                </svg>
                                            </span>
                                            {{ $t('remove_all') }}
                                        </button>
                                    </div>
                                </div>
                                <div class="dataTables_wrapper dt-bootstrap4 no-footer mt-3">
                                    <div class="table-responsive min-h-300px">
                                        <DxDataGrid id="gridContainer" :key="$i18n.locale" :show-borders="true" key-expr="id" :data-source="campaignItemList" :allow-column-reordering="true"  :allow-column-resizing="true" :column-auto-width="true" :row-alternatin-enabled="true"
                                                    :hover-state-enabled="true" :show-row-lines="true" @exporting="this.$onExporting($event , 'Campaign-items')" @row-updating="onRowUpdating"> 
                                                <DxFilterRow :visible="true"/>
                                                <DxHeaderFilter :visible="true"/>
                                                <DxGroupPanel :visible="true"/>      
                                                <DxExport :enabled="this.$getUser().is_allow_export" :formats="['xlsx','pdf']" :allow-export-selected-data="false"/>
                                                <DxPaging :page-size="10"/>
                                                <DxPager :visible="false" :allowed-page-sizes="pageSizes" :show-page-size-selector="showPageSizeSelector" :show-info="true" :show-navigation-buttons="true"/>
                                                <DxSearchPanel :visible="true"/>
                                                <DxScrolling
                                                    mode="virtual"
                                                    row-rendering-mode="virtual"
                                                />

                                                <DxColumn data-field="isSelected" caption="#" :allow-filtering="false" alignment="center" cell-template="is-selected-cell-template" :allow-editing="false" :allow-exporting="false"/>
                                                <DxColumn data-field="product_group_name" :caption="$t('product_group')" header-cell-template="product-group-header" alignment="left" cell-template="product_group-cell-template" :set-cell-value="setProductType"/>
                                                <DxColumn data-field="product_type_name" :caption="$t('product_type')" header-cell-template="product-type-header" alignment="left" cell-template="product_type-cell-template"/>
                                                <DxColumn data-field="product_detail_name" :caption="$t('product_detail')" header-cell-template="product-detail-header" alignment="left" cell-template="product_detail-cell-template"/>
                                                <DxColumn data-field="price_type_name" :caption="$t('price_type')" header-cell-template="price-type-header" alignment="left" cell-template="price_type-cell-template"/>
                                                <DxColumn data-field="discount" :sorting-method="this.$numericSort" :caption="$t('discount')" alignment="right" cell-template="discount-cell-template"/>

                                                <template #product-group-header>
                                                        <div>{{ $t('product_group') }}</div>  
                                                </template>
                                                <template #product-type-header>
                                                        <div>{{ $t('product_type') }}</div>
                                                </template>
                                                <template #product-detail-header>
                                                        <div>{{ $t('product_detail') }}</div>
                                                </template>
                                                <template #price-type-header>
                                                        <div>{{ $t('price_type') }}</div>
                                                </template>

                                                <template #is-selected-cell-template="{ data }"> 
                                                    <span>
                                                        <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center" v-if="data.data.id !== null && data.data.id !== ''">
                                                            <input class="form-check-input" type="checkbox" v-model="data.data.isSelected" @change="this.onSelectItem(data.data)" />
                                                        </div>
                                                    </span>
                                                </template>
                                                <template #product_group-cell-template="{ data }"> 
                                                    <span> 
                                                        {{ data.data.product_group_name }}
                                                    </span>
                                                </template>
                                                <template #product_type-cell-template="{ data }"> 
                                                    <span> 
                                                        {{ data.data.product_type_name }}
                                                    </span>
                                                </template>
                                                <template #product_detail-cell-template="{ data }"> 
                                                    <span> 
                                                        {{ data.data.product_detail_name }}
                                                    </span>
                                                </template>
                                                <template #price_type-cell-template="{ data }"> 
                                                    <span> 
                                                        {{ data.data.price_type_name }}
                                                    </span>
                                                </template>
                                                <template #discount-cell-template="{ data }"> 
                                                    <span> 
                                                        {{ data.data.discount }}
                                                    </span>
                                                </template>
                                        </DxDataGrid>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                            <div class="card-body pb-0">
                                <form id="kt_ecommerce_settings_general_form"
                                    class="form fv-plugins-bootstrap5 fv-plugins-framework">                                            
                                    <div class="fv-row mb-7">
                                        <label class="fs-6 fw-bold form-label mt-3">
                                            <span>{{ $t('description') }}</span>
                                        </label>
                                        <textarea class="form-control" name="description" v-model="form.description"></textarea>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="d-grid gap-2">
                            <button type="button" class="btn btn-primary" @click="this.saveData()" data-kt-indicator="on" :disabled="campaignItemList.length == 0">
                                <span class="svg-icon svg-icon-2"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.3" d="M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                <path d="M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                </svg>
                                </span> 
                                <strong v-if="!this.isProgressing"> {{ $t('update_sales_role_campaign') }} </strong> 
                                    <span class="indicator-progress" v-if="this.isProgressing">
                                        {{ $t('saving_data') }} <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                    </span>
                            </button>
                        </div>                 
                    </div>
                </div>
            </div><div class="card card-xxl-stretch tab-pane fade" id="kt_accounting_2" role="tabpanel">
                <div class="row p-10">
                    <div class="col-lg-12">
                        <div class="card card-xxl-stretch bg-lighten border border-gray-300">
                            <div class="card-body p-5">
                                <form id="kt_ecommerce_settings_general_form"
                                    class="form fv-plugins-bootstrap5 fv-plugins-framework">                                
                                    <div class="fv-row row">
                                        <div class="col-lg-6">
                                            <label class="fs-6 fw-bold form-label mt-3">
                                                <span>{{ $t('accounting_plan') }}</span>
                                            </label>
                                            <div class="input-group mb-5">
                                                <input type="text" class="form-control"
                                                    name="company_name" v-model="form.accounting_plan">
                                                <span class="input-group-text m-0" id="basic-addon2">
                                                    <i class="fas fa-search fs-4 me-3"></i> {{ $t('search') }} 
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div> 
                    </div> 
                </div>
            </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="kt_modal_add_item" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-modal="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content"  >
                <div class="modal-header bg-primary" id="kt_modal_add_user_header">
                    <h2 class="modal-title fw-bolder col-md-11 text-white">
                        <span v-if="this.modalType == 'addItem'"> {{ $t('add') }} </span> 
                        <span v-if="this.modalType == 'editItem'"> {{ $t('edit') }} </span> {{ $t('item') }}                                           
                    </h2>   
                    <div class="btn btn-icon btn-sm btn-active-icon-primary">
                        <i class="bi bi-gear fs-2 mt-1 cursor-pointer text-white text-hover-dark"></i>  
                    </div>
                    <div class="btn btn-icon btn-sm btn-active-icon-primary"
                        data-bs-dismiss="modal" aria-label="Close" ref="closeModal">
                        <span class="svg-icon svg-icon-1 text-white text-hover-dark">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none">
                                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1"
                                    transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                                <rect x="7.41422" y="6" width="16" height="2" rx="1"
                                    transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                            </svg>
                        </span>
                    </div>
                </div>
                <div class="modal-body pt-0" :class="{'overlay overlay-block': this.isItemSaving == true}">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="card card-flush">
                                <div class="card-body pt-0 pb-0">
                                    <form class="form">
                                        <div class="card-body border-top">
                                            <div class="row mb-2">
                                                <label class="col-lg-4 col-form-label fw-bold fs-6">
                                                    <span>{{ $t('product_group') }}</span>
                                                </label>
                                                <div class="col-lg-8 fv-row">
                                                    <Select2 v-model="campaignForm.product_group_id" :options="productGroupList" @select="onChangeProductGroup(true)" :settings="{ width: '100%', dropdownParent: '#kt_modal_add_item .modal-content'}"/> 
                                                </div>
                                            </div>
                                            <div class="row mb-2">
                                                <label class="col-lg-4 col-form-label fw-bold fs-6">
                                                    <span>{{ $t('product_type') }}</span>
                                                </label>
                                                <div class="col-lg-8 fv-row">
                                                    <Select2 v-model="campaignForm.product_type_id" :options="productTypeList"  @select="onChangeProductType(true)" :settings="{ width: '100%', dropdownParent: '#kt_modal_add_item .modal-content'}"/> 
                                                </div>
                                            </div>
                                            <div class="row mb-2">
                                                <label class="col-lg-4 col-form-label fw-bold fs-6">
                                                    <span>{{ $t('product_detail') }}</span>
                                                </label>
                                                <div class="col-lg-8 fv-row">
                                                    <Select2 v-model="campaignForm.product_detail_id" :options="productDetailList" :settings="{ width: '100%', dropdownParent: '#kt_modal_add_item .modal-content'}"/> 
                                                </div>
                                            </div>
                                            <div class="row mb-2">
                                                <label class="col-lg-4 col-form-label fw-bold fs-6">
                                                    <span>{{ $t('price_type') }}</span>
                                                </label>
                                                <div class="col-lg-8 fv-row">
                                                    <Select2 v-model="campaignForm.price_type_id" :options="priceTypeList" :settings="{ width: '100%', dropdownParent: '#kt_modal_add_item .modal-content'}"/> 
                                                </div>
                                            </div>
                                            <div class="row mb-2">
                                                <label class="col-lg-4 col-form-label fw-bold fs-6">
                                                    <span>{{ $t('discount') }} %</span>
                                                </label>
                                                <div class="col-lg-8 fv-row">
                                                    <CurrencyInput type="text" class="form-control text-end" name="discount" v-model="this.campaignForm.discount" :precision="2" @focus="$event.target.select()" :min="0" />
                                                </div>
                                            </div> 
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12">
                            <div class="card card-flush mt-4" id="kt_contacts_list">
                                <div class="d-grid gap-2"> 
                                    <button type="button" class="btn btn-success btn-lg" v-if="this.modalType == 'addItem'"
                                        @click="this.createCampaignItem()" :disabled="this.isModalButtonDisabled">
                                        <span class="indicator-label">{{ $t('add_item') }}</span> 
                                    </button>
                                    <button type="button" class="btn btn-primary btn-lg" v-if="this.modalType == 'editItem'"
                                        @click="this.editCampaignItem()" :disabled="this.isModalButtonDisabled">
                                        <span class="indicator-label">{{ $t('update') }}</span> 
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="overlay-layer bg-dark bg-opacity-5" v-if="this.isItemSaving == true">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">{{ $t('loading') }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
   </div>
</template>

<script>

import axios from 'axios' 
   
import moment from 'moment';
import { DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel } from 'devextreme-vue/data-grid';
 
export default {
  name: "CampaignUpdate",
  components:{
        DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel
  }, 
  data() {
    return {
      campaignItemList: [],
      salesChannelList:[],
      productDetailList: [],
      productGroupList: [],
      productTypeList: [],
      priceTypeList: [],
      searchbar: '',
      isProgressing: false,
      form:{
        code: null,
        name: null,
        description: null,
        is_default: false,
        is_always: true,
        is_active: true,
        accounting_plan: null,
        start_date: moment(),
        end_date: moment().add(1, 'days'),
        payment_value: 0,
        sales_channel_id: '-1',
        payment_type_id: '-1',
        shipping_type_id: '-1'
      },
      campaignForm: {
        id: null,
        product_detail_id: '-1',
        product_type_id: '-1',
        product_group_id: '-1',
        discount: 0.00,
        tmp_session_id: null,
        price_type_id: '-1'
      },
      modalType: 'addItem',
      isItemSaving: false,
      isModalButtonDisabled: false,
      activeTab: 'inputForm',
      menuSelection: '/SalesRoleHelppage',
      iconView : false,
      pageSize: 10,
      pageIndex: 0,
    };
  }, 
  computed: {
    searchableList() {
      return this.campaignItemList.filter(p => { 
        return p.name.toLowerCase().indexOf(this.searchbar.toLowerCase()) != -1;
      });
    },
   isItemButtonDisabled() {
       return this.campaignItemList.find(item => item.isSelected == true );
    },
    showPageSizeSelector() {
        return this.campaignItemList.length > this.pageSize;
    },
    pageSizes() {
        let arr = [];
        let x = 1;
        let loop = (this.campaignItemList.length / this.pageSize);
        for (let i = 1; i <= loop && i <= 5; i++) {
            arr.push(this.pageSize * x);
            x++;
        }
        if(loop > 5) arr.push(100);
        if(loop > 1) arr.push('all');
        return arr;
    }
  },
  methods: {        
        getData() {
            const params = this.form; 
            this.$setSessionStorage('refreshList', true);
            const queryParameter = {
                id: this.$getSessionStorage('record_id'),
                session_id: this.$getUser().session_id
            };
            if(params.sales_channel == null ){ params.branch_id = '-1';}
            axios.post('/api/Campaign/GetCampaign', queryParameter, {'Content-Type': 'application/json'})
            .then((response) => {     
                this.form = { 
                    id: response.data.campaign_header.id, 
                    code: response.data.campaign_header.code,
                    name: response.data.campaign_header.name,
                    description: response.data.campaign_header.description,
                    is_default: response.data.campaign_header.is_default,
                    start_date: response.data.campaign_header.start_date,
                    end_date: response.data.campaign_header.end_date,
                    is_always: response.data.campaign_header.is_always,
                    is_active: response.data.campaign_header.is_active,
                    payment_value: response.data.campaign_header.payment_value,
                    sales_channel_id: (response.data.campaign_header.sales_channel_id == null || response.data.campaign_header.sales_channel_id == '') ? '-1' : response.data.campaign_header.sales_channel_id,
                    payment_type_id: (response.data.campaign_header.payment_type_id == null || response.data.campaign_header.payment_type_id == '') ? '-1' : response.data.campaign_header.payment_type_id,
                    shipping_type_id: (response.data.campaign_header.shipping_type_id == null || response.data.campaign_header.shipping_type_id == '') ? '-1' : response.data.campaign_header.shipping_type_id
                };  
                this.form.is_default = response.data.campaign_header.is_default == 1 ? true : false;
                this.form.is_always = response.data.campaign_header.is_always == 1 ? true : false;
                this.form.is_active = response.data.campaign_header.is_active == 1 ? true : false;
                this.form.start_date = response.data.campaign_header.start_date == null ? moment() : response.data.campaign_header.start_date;
                this.form.end_date = response.data.campaign_header.end_date == null ? moment().add(1, 'days') : response.data.campaign_header.end_date;

                this.campaignItemList = response.data.campaign_items;
                if(this.campaignItemList.length > 0){
                    this.$setSessionStorage('tmp_session_id', response.data.campaign_items[0].tmp_session_id);
                }
                const parameters = { 
                    session_id: this.$getUser().session_id,
                    list_name: ["sales_channel", "product_group", "product_type"],
                    account_type: 6 // yalnızca account settings listesi çekilecek ise gerekli
                }; 
                axios.post('/api/Helper/GeneralLists', parameters, {'Content-Type': 'application/json'}).then((response) => {
                    this.salesChannelList = response.data.sales_channel;
                    this.productGroupList = response.data.product_group;
                    this.productGroupList.unshift({ id: '-1', text: this.$t('all')});
                    this.salesChannelList.unshift({ id: '-1', text: this.$t('select_an_option')});

                    const params = {
                        session_id: this.$getUser().session_id,
                        list_types: [
                            {
                                list_type: 7,
                                list_name: "product_group"
                            },
                            {
                                list_type: 11,
                                list_name: "payment_type"
                            },
                            {
                                list_type: 12,
                                list_name: "shipping"
                            },
                            {
                                list_type: 13,
                                list_name: "price_type"
                            }
                        ],
                    };
                    axios.post("/api/Helper/GetMultiLists", params, {'Content-Type': 'application/json'}).then((listResponse) => {
                        this.priceTypeList = listResponse.data.price_type;  
                        this.paymentTypeList = listResponse.data.payment_type;
                        this.shippingTypeList = listResponse.data.shipping;
                        this.priceTypeList.unshift({ id: '-1', text: this.$t('all')});
                        this.paymentTypeList.unshift({ id: '-1', text: this.$t('select_an_option')});
                        this.shippingTypeList.unshift({ id: '-1', text: this.$t('select_an_option')});
                        this.onChangeProductGroup(false);
                        this.onChangeProductType(false);
                        this.$Progress.finish();
                    })
                    .catch((error) => {
                        console.error(error); 
                        this.$Progress.finish();
                    });
                })
                .catch((error) => {
                    console.error(error); 
                    this.$Progress.finish();
                });       
            })
            .catch((error) => {
                console.error(error);
                this.$Progress.finish();
                this.$swal(this.$t('failed'), this.$t('data_could_not_be_savedplease_refresh_the_page_and_try_again'), "error");   
            });  
        },
        openItemModal(value) {
            try {
            this.$refs.btnAddItem.blur();
            this.$refs.btnEditItem.blur();
        } catch(Err){ console.error(Err);}
        
            this.modalType = value;
            this.isItemSaving = false;
            this.isModalButtonDisabled = false;
            this.productTypeList = [{ id: '-1', text: this.$t('all')}];
            this.productDetailList = [{ id: '-1', text: this.$t('all')}];
            this.campaignForm.product_group_id = '-1';
            this.campaignForm.product_type_id = '-1';
            this.campaignForm.product_detail_id = '-1';
            this.campaignForm.price_type_id = '-1';
            this.campaignForm.discount = 0.00;

            if (this.modalType == 'editItem') {                        
                this.campaignItemList.forEach((item) => {
                    if (item.isSelected) {
                        this.campaignForm.id = item.id;
                        this.campaignForm.product_group_id = (item.product_group_id == null || item.product_group_id == '') ? '-1' : item.product_group_id;
                        this.campaignForm.product_type_id = (item.product_type_id == null || item.product_type_id == '') ? '-1' : item.product_type_id;
                        this.campaignForm.product_detail_id = (item.product_detail_id == null || item.product_detail_id == '') ? '-1' : item.product_detail_id;
                        this.campaignForm.price_type_id = (item.price_type_id == null || item.price_type_id == '') ? '-1' : item.price_type_id; 
                        this.campaignForm.discount = item.discount.replace(/,/g, '');                        
                        this.onChangeProductGroup(false);
                        this.onChangeProductType(false);
                    }
                }); 
            } else {            
                this.salesChannelList.forEach((value) => {
                    if(value.is_default){
                        this.campaignForm.sales_channel_id = value.id;
                    }
                });  
            }
        },
        onSelectItem(item) {
            this.campaignItemList.forEach((value) => { 
                if (item.id !== value.id) {
                    value.isSelected = false;
                }
            });
        },
        saveData(){
            this.isProgressing = true;
            const params = {
                id: this.$getSessionStorage('record_id'),
                session_id: this.$getUser().session_id,
                tmp_session_id: this.$getSessionStorage('tmp_session_id'),
                code: this.form.code,
                name: this.form.name,
                start_date: this.form.start_date,
                end_date: this.form.end_date,
                payment_value: this.form.payment_value,
                description: this.form.description == null ? '' : this.form.description,
                branch_id: this.form.branch_id == -1 ? null : this.form.branch_id, 
                is_default: this.form.is_default == true ? 1 : 0,
                is_always: this.form.is_always == true ? 1 : 0,
                is_active: this.form.is_active == true ? 1 : 0,                
                sales_channel_id: this.form.sales_channel_id == '-1'?  null : this.form.sales_channel_id,
                payment_type_id: this.form.payment_type_id == '-1'?  null : this.form.payment_type_id,
                shipping_type_id: this.form.shipping_type_id == '-1'?  null : this.form.shipping_type_id,
            };  
            const that = this;   
            if(params.is_always == 1){
                params.start_date = null;
                params.end_date = null;
            }
            else{
                params.start_date = moment(params.start_date).format('YYYY-MM-DD[T]HH:mm:ss');
                params.end_date = moment(params.end_date).format('YYYY-MM-DD[T]HH:mm:ss');  
            }
            axios.post('api/Campaign/UpdateCampaign', params, {'Content-Type': 'application/json'})
            .then((response) => {  
                if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){ 
                    this.$swal(this.$t('success'), this.$t('data_saved_succesfully'), 'success');   
                    this.$setSessionStorage('refreshList', true);
                }
            })
            .catch(() => { 
                this.$swal(this.$t('failed'), this.$t('data_could_not_be_savedplease_refresh_the_page_and_try_again'), 'error');
            })
            .finally(() => { 
                setTimeout(() => {
                    that.isProgressing = false;
                }, 500);
            });
        },
        deleteItem() { 
            this.$swal.fire({
                title: this.$t('are_you_sure_you_want_to_delete_this_data'),
                confirmButtonColor: '#f1416c',
                showDenyButton: false,
                showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
                confirmButtonText: this.$t('yes'),
                icon: 'warning'
            }).then((result) => { 
                if (result.isConfirmed) {
                    const queryParameter = {
                        id: this.$getSessionStorage('record_id'),
                        session_id: this.$getUser().session_id,
                    };
                    axios.post("/api/Campaign/DeleteCampaign", queryParameter, {'Content-Type': 'application/json'})
                    .then((response) => { 
                        if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){ 
                            this.$setSessionStorage('refreshList', true);
                            this.$router.push({ name: 'CampaignList' });
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        this.$swal(this.$t('failed'), this.$t('data_could_not_be_savedplease_refresh_the_page_and_try_again'), "error");
                    });
                }
            })  
        },
        onChangeProductGroup(isSetDefault) {
            const params = {
                session_id: this.$getUser().session_id,
                list_type: 16, // Product Type: 16
                parent_id: this.campaignForm.product_group_id
            };
            axios.post("/api/Helper/GetProductTypeParentList", params, {'Content-Type': 'application/json'}).then((campaignItemResponse) => { 
                this.productTypeList = campaignItemResponse.data;
                this.productTypeList.unshift({ id: '-1', text: this.$t('all')});
                if(isSetDefault) {
                    this.campaignForm.product_type_id = '-1';
                    this.productTypeList.forEach((value) => {
                        if(value.is_default) {
                            this.campaignForm.product_type_id = value.id;
                        }
                    });                
                }
            })
            .catch((error) => {
                console.error(error);
            });
        },
        onChangeProductType(isSetDefault) {
            const params = {
                session_id: this.$getUser().session_id,
                parent_id: this.campaignForm.product_type_id
            };
            axios.post("/api/Helper/GetProductDetailParentList", params, {'Content-Type': 'application/json'}).then((response) => { 
                this.productDetailList = response.data;
                this.productDetailList.unshift({ id: '-1', text: this.$t('all')}); 
                if(isSetDefault) {
                    this.campaignForm.product_detail_id = '-1';
                    this.productDetailList.forEach((value) => {
                        if(value.is_default) {
                            this.campaignForm.product_detail_id = value.id;
                        }
                    });
                }
            })
            .catch((error) => {
                console.error(error);
            });
        },
        createCampaignItem(){ 
            const params = this.campaignForm; 
            this.isModalButtonDisabled = true;
            this.isItemSaving = true;
            const that = this;
            params.session_id = this.$getUser().session_id; 
            params.tmp_session_id = this.$getSessionStorage('tmp_session_id'); 
            params.campaign_id = this.$getSessionStorage('record_id');
            params.product_group_id = params.product_group_id == '-1'?  null : params.product_group_id;
            params.product_type_id = params.product_type_id == '-1'?  null : params.product_type_id;
            params.product_detail_id = params.product_detail_id == '-1'?  null : params.product_detail_id;
            params.price_type_id = params.price_type_id == '-1'?  null : params.price_type_id;
            
            axios.post('/api/Campaign/AddCampaignItem', params, {'Content-Type': 'application/json'})
            .then((response) => { 
                if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                    this.campaignItemList = response.data;
                    this.$setSessionStorage('tmp_session_id', response.data[0].tmp_session_id);
                    this.$refs.closeModal.click();
                } else {
                    this.campaignForm.product_group_id = this.campaignForm.product_group_id == null ? '-1' : this.campaignForm.product_group_id;
                    this.campaignForm.product_type_id = this.campaignForm.product_type_id == null ? '-1' : this.campaignForm.product_type_id;
                    this.campaignForm.product_detail_id = this.campaignForm.product_detail_id == null ? '-1' : this.campaignForm.product_detail_id;
                    this.campaignForm.price_type_id = this.campaignForm.price_type_id == null ? '-1' : this.campaignForm.price_type_id;
                }
                this.isItemSaving = false;
            })
            .catch(() => { 
                this.isItemSaving = false;
            })
            .finally(() => { 
                setTimeout(() => {
                    that.isItemSaving = false;
                    that.isModalButtonDisabled = false;
                }, 500);
            });
        },
        editCampaignItem(){  
            const params = this.campaignForm; 
            this.isModalButtonDisabled = true;
            this.isItemSaving = true;
            const that = this;
            params.session_id = this.$getUser().session_id; 
            params.tmp_session_id = this.$getSessionStorage('tmp_session_id'); 
            params.campaign_id = this.$getSessionStorage('record_id');
            params.product_group_id = params.product_group_id == '-1'?  null : params.product_group_id;
            params.product_type_id = params.product_type_id == '-1'?  null : params.product_type_id;
            params.product_detail_id = params.product_detail_id == '-1'?  null : params.product_detail_id;
            params.price_type_id = params.price_type_id == '-1'?  null : params.price_type_id; 
            
            axios.post('/api/Campaign/UpdateCampaignItem', params, {'Content-Type': 'application/json'})
            .then((response) => { 
                if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){ 
                    this.campaignItemList = response.data;
                    this.$setSessionStorage('tmp_session_id', response.data[0].tmp_session_id);
                    this.$refs.closeModal.click(); 
                } else {
                    this.campaignForm.product_group_id = this.campaignForm.product_group_id == null ? '-1' : this.campaignForm.product_group_id;
                    this.campaignForm.product_type_id = this.campaignForm.product_type_id == null ? '-1' : this.campaignForm.product_type_id;
                    this.campaignForm.product_detail_id = this.campaignForm.product_detail_id == null ? '-1' : this.campaignForm.product_detail_id;
                    this.campaignForm.price_type_id = this.campaignForm.price_type_id == null ? '-1' : this.campaignForm.price_type_id;
                }
                this.isItemSaving = false;
            })
            .catch(() => { 
                this.isItemSaving = false;                
            })
            .finally(() => { 
                setTimeout(() => {
                    that.isItemSaving = false;
                    that.isModalButtonDisabled = false;
                }, 500);
            });
        },
        deleteCampaignItem(){ 
            this.$swal.fire({
                title: this.$t('are_you_sure_you_want_to_delete_this_data'),
                confirmButtonColor: "#E53935",
                showDenyButton: false,
                showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
                confirmButtonText: this.$t('yes'),
                icon: 'warning'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.campaignItemList.forEach((item) => {
                    if(item.isSelected) {
                        const params = {
                            id: item.id,
                            session_id: this.$getUser().session_id,
                            tmp_session_id: this.$getSessionStorage('tmp_session_id')
                        };
                        axios.post('/api/Campaign/DeleteCampaignItem', params, {'Content-Type': 'application/json'})
                        .then((response) => { 
                            if(response.data != null){  
                                this.campaignItemList = response.data;
                                this.$setSessionStorage('tmp_session_id', response.data[0].tmp_session_id);
                                this.$swal(this.$t('deleted'), this.$t('selected_item_deleted'), 'warning');    
                                this.$refs.closeModal.click(); 
                            } 
                        })
                        .catch(() => { 
                            
                        }); 
                    }
                  });
                }
            }); 
        },
        deleteAllCampaignItems(){
            this.$swal.fire({
                title: this.$t('are_you_sure_you_want_to_delete_all_items'),
                confirmButtonColor: "#E53935",
                showDenyButton: false,
                showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
                confirmButtonText: this.$t('yes'),
                icon: 'warning'
            }).then((result) => {
                if (result.isConfirmed) { 
                    const params = {
                        session_id: this.$getUser().session_id,
                        tmp_session_id: this.$getSessionStorage('tmp_session_id')
                    };
                    axios.post('/api/Campaign/DeleteAllCampaignItems', params, {'Content-Type': 'application/json'})
                    .then((response) => { 
                        if(response.data != null){  
                            this.campaignItemList = [];
                            this.$swal(this.$t('deleted'), this.$t('all_items_deleted'), 'warning');    
                            this.$refs.closeModal.click(); 
                        } 
                    })
                    .catch(() => { 
                        
                    });  
                } 
            }); 
        },
        onChangePaymentValue() {
            if (parseInt(this.form.payment_value) > 0) {
                this.form.end_date = moment(this.form.start_date, "YYYY-MM-DD").add(parseInt(this.form.payment_value), 'days');
            }
        },
        async helpPageViewIcon(){
            const queryparameter = {
                session_id : this.$getUser().session_id,
                menu_selection : '/SalesRoleHelppage'
            };
            axios.post('api/HelpPage/HelpPagesContent', queryparameter, {'Content-Type': 'application/json'})
            .then((response) => { 
                if(!response.data.error){ 
                    this.iconView = response.data;
                }
            })
        },
    }, 
    created() {
        this.helpPageViewIcon();
        this.$setSessionStorage('refreshList', true);
        this.getData();
    }
}; 
</script>